export function formatRelativeShort(value: string | null | undefined): string {
  if (!value) return 'Never';
  const then = new Date(value).getTime();
  if (!Number.isFinite(then)) return 'Never';

  const diffSec = Math.round((Date.now() - then) / 1000);
  if (diffSec < 45) return 'just now';

  const diffMin = Math.round(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;

  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;

  const diffDay = Math.round(diffHr / 24);
  if (diffDay < 30) return `${diffDay}d ago`;

  const diffMonth = Math.round(diffDay / 30);
  if (diffMonth < 12) return `${diffMonth}mo ago`;

  return `${Math.round(diffMonth / 12)}y ago`;
}

export function formatCountdownPhrase(value: string | null | undefined, now: number): string | null {
  if (!value) return null;
  const target = new Date(value).getTime();
  if (!Number.isFinite(target)) return null;

  const seconds = Math.ceil((target - now) / 1000);
  if (seconds <= 0) return 'any moment';
  if (seconds < 60) return `in ${seconds}s`;

  return `in ${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}
